import {Resources} from "app/app.resource";
import {uniq, first, find} from 'lodash';
import {ExchangeRate} from "app/model/exchangeRate";
import {Amount} from "app/model/amount";
import {currencyMapper, deliveryMethodsFeeMapper} from "./helpers/resolver";
import {CalculatorProvider} from "./calculator.provider";
import {availableCountries} from "app/static/countries";

const DEFAULT_AMOUNT = 50000;

export class CalculatorResolver {
    static getAvailableDirections() {
        const CALCULATOR = CalculatorProvider.init;
        return CALCULATOR.directions || Resources.getDirections();
    }

    static async getAvailableCurrencies(countryIn, countryOut) {
        const currencyPairs = await Resources.getAvailableCurrencies(countryIn, countryOut);
        const currenciesIn = uniq(currencyPairs.map((item) => item.currency_in.name));

        return currencyMapper(currencyPairs, currenciesIn);
    }

    static getDefaultAmount(availableCurrencies, type) {
        const CALCULATOR = CalculatorProvider.init;
        const currency = (type === 'in' ? CALCULATOR.currencyIn : CALCULATOR.currencyOut) ||
            first(availableCurrencies);
        const amount = type === 'in' ? (CALCULATOR.amountIn || DEFAULT_AMOUNT) : DEFAULT_AMOUNT;

        return Amount.createMoney(amount, currency);
    }

    static async getExchangeRate(currencyIn, currencyOut, amount) {
        const result = await Resources.getExchangeRate(currencyIn, currencyOut, amount);
        const rate = result.data.attributes;

        return ExchangeRate.create({...rate, base: rate.currency_base, quoted: rate.currency_quoted});
    }

    static updateCurrency(availableCurrencies, amount, countryIn) {
        const currencyFromCountry = find(availableCountries, {code: countryIn});
        const currency = availableCurrencies.includes(currencyFromCountry.currency) ?
            currencyFromCountry.currency : first(availableCurrencies);

        return Amount.createMoney(amount.getAmount, currency);
    }

    static async getAvailableDeliveryMethods({countryIn, currencyIn, countryOut, currencyOut, amount}) {
        const result = await Resources.getDeliveryMethods({countryIn, currencyIn, countryOut, currencyOut, amount});
        const methods = result.data.attributes.transfer_types;

        return deliveryMethodsFeeMapper(methods, currencyIn);
    }
}